import { DOMAIN_NAME } from '~/constants/urls';
import { useFeatureFlag } from '~/hooks/use-feature-flag';

/**
 * 現在のドメインに基づいてクライアント認証URLを取得する
 * kakaritsuke.medixs.jp で終わるドメインの場合は MEDIXS_KAKARITSUKE_S_URL を使用
 * それ以外の場合は PHARMS_S_URL を使用
 */
export const useClientAuthUrl = (): string => {
  const isPharmacyTwoDomain = useFeatureFlag('Issue12674-pharmacy_two_domain');

  if (typeof window === 'undefined') {
    // SSR時はデフォルトのURLを返す
    return process.env.pharmsClientAuthUrl || 'https://localhost:1445';
  }

  if (!isPharmacyTwoDomain) {
    return process.env.pharmsClientAuthUrl || 'https://localhost:1445';
  }

  const hostname = window.location.hostname;

  if (hostname.endsWith(DOMAIN_NAME)) {
    return process.env.medixsKakaritsukeSUrl || 'https://localhost:1445';
  }

  return process.env.pharmsClientAuthUrl || 'https://localhost:1445';
};
